<template>
  <div>
    <b-modal
      ref="modal-settings-tracking-homework-status"
      title="Tracking"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="xlg"
      hide-footer
    >
      <b-table
        ref="ref-table-tracking-homework-status"
        small
        :items="myProvider"
        :fields="fields"
        :filter="[]"
        :current-page="paginate.currentPage"
        :per-page="paginate.perPage"
        responsive
        sticky-header="70vh"
        primary-key="id"
        show-empty
        :busy.sync="isBusy"
        :empty-text="$t('No matching records found')"
        class="font-small-3"
      >
        <template #cell(abbreviation)="data">
          <span> {{ data.value | capitalize }} </span><br />
          <span style="opacity: 0.7">
            {{ data.item.description | capitalize }}
          </span>
        </template>
        <template #cell(viatic_cost)="data">
          <span class="text-success"> S/.{{ data.value | currency }} </span>
        </template>
        <template #cell(created_by)="data">
          <span> {{ data.value | capitalize }} </span><br />
          <span style="opacity: 0.7">
            {{ data.item.updated_at | myGlobalDay }}
          </span>
        </template>
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="
              data.value == 'Active' ? 'light-success' : 'light-warning'
            "
            class="text-capitalize"
          >
            <span> {{ data.value | capitalize }}</span>
          </b-badge>
        </template>
        <template #cell(viatic_status)="data">
          <b-badge
            pill
            :variant="data.value == 'Apply' ? 'light-success' : 'light-warning'"
            class="text-capitalize"
          >
            <span> {{ data.value | capitalize }}</span>
          </b-badge>
        </template>
        <template #cell(tracking)="data">
          <feather-icon
            @click="getTracking(data.item)"
            icon="AlignJustifyIcon"
            size="17"
            class="cursor-pointer ml-1"
            v-b-tooltip.top
            title="Edit"
          />
        </template>
        <template #cell(actions)="data">
          <feather-icon
            @click="changeStatus(data.item)"
            :icon="typeTab == 1 ? 'ThumbsDownIcon' : 'ThumbsUpIcon'"
            size="17"
            class="cursor-pointer"
            :class="typeTab == 1 ? 'text-danger' : 'text-success'"
            v-b-tooltip.top
            :title="typeTab == 1 ? 'Inactive' : 'Active'"
          />
          <feather-icon
            @click="editStatus(data.item)"
            icon="EditIcon"
            size="17"
            class="cursor-pointer text-warning ml-1"
            v-b-tooltip.top
            title="Edit"
          />
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HomeworkStatusService from "@/views/settings/views/homework-status/service/homework-status.service";
import modalMixin from "@/mixins/modal";
export default {
  mixins: [modalMixin],
  props: {
    dataType: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "abbreviation",
          label: "abbreviation",
          visible: true,
        },
        {
          key: "status",
          label: "status",
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "viatic_cost",
          label: "Viatic Cost",
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "viatic_status",
          label: "Viatic Status",
          visible: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "created_by",
          label: "created by",
          visible: true,
        },
      ],
      isBusy: false,
      searchQuery: "",
      paginate: {
        currentPage: 1,
        perPage: 10,
        startPage: 1,
        toPage: 1,
      },
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {},
  methods: {
    async myProvider(ctx) {
      try {
        await this.addPreloader();
        const { data } = await HomeworkStatusService.getHomeworkStatus({
          id: this.dataType.data.id,
        });
        this.paginate.currentPage = data.current_page;
        this.paginate.perPage = data.per_page;
        this.paginate.startPage = data.current_page;
        this.paginate.toPage = data.last_page;
        this.dataMeta = {
          from: data.from,
          to: data.to,
          of: data.total,
        };
        return data || [];
      } catch (error) {
        console.log(error);
      } finally {
        await this.removePreloader();
      }
    },
  },
  mounted() {
    this.toggleModal("modal-settings-tracking-homework-status");
  },
};
</script>

<style>
.modal .modal-xlg {
  min-width: 60vw;
  width: 100%;
}
</style>
